const { createImage, duplicateImage } = require('./Image');

const baseQuirk = {
  _version: 1,
  id: '',
  displayName: '',
  description: '',
  image: createImage(),
};

const createQuirk = (overrides = {}) => ({
  ...baseQuirk,
  ...overrides
});

const duplicateQuirk = quirk => ({
  ...quirk,
  image: duplicateImage(quirk.image)
});

module.exports = {
  createQuirk,
  duplicateQuirk
};
